import {zx} from 'shared/type'

export const roleMd = {
  admin: {
    label: 'Admin',
    desc: 'Admins can do anything in the workspace'
  },
  forecaster: {
    label: 'Forecaster',
    desc: 'Participate on question forecasting. This includes: proposing conditionals, commenting and submitting forecasts.'
  },
  viewer: {
    label: 'Viewer',
    desc: 'View questions and the results of forecasting. They can also vote on conditionals and see results.'
  },
  reader: {
    label: 'Results Viewer',
    desc: 'View question results when enabled for results viewing only'
  }
} satisfies Record<string, {label: string; desc: string}>

export const zRoles = zx.enumFromObjKeys(roleMd)
export type Role = keyof typeof roleMd
export const roles = Object.keys(roleMd) as Role[]
